// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"16919a80","226":"0be97eab","238":"0f9e2b1c","321":"3643756f","801":"34be1dcf"}[chunkId] + ".chunk.js";
};